export function createRedirectParams(
  urlPathname: string,
  urlQueryParams: string,
) {
  if (urlPathname === "" || urlPathname === "/") {
    return "";
  }
  const pathname = encodeURIComponent(urlPathname);
  const params = encodeURIComponent(urlQueryParams.split("?")[1] || "");
  const redirectPath = urlPathname ? `?redirect=${pathname}` : "";
  const queryParams = urlQueryParams ? `&params=${params}` : "";
  return `${redirectPath}${queryParams}`;
}
